import { render, staticRenderFns } from "./technicReport.vue?vue&type=template&id=70698cef&"
import script from "./technicReport.vue?vue&type=script&lang=js&"
export * from "./technicReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports